export const CART_PREVIEW_ITEM_BACKGROUND = 'transparent';
export const BUTTON_CONTAINER_TOP_BORDER = 'none';
export const CHECKOUT_BUTTON_PADDING = '1.5rem';
